import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { listScmIdentities } from './api'
import type { ScmIdentity } from './types'
import useLoginStore from '@/store/LoginStore'

/**
 * GitHub-login → Moly-member map for the current workspace, used to attribute PR authors to
 * members. Fetched once and cached (identities change rarely). Keyed by lowercased login.
 */
export function useScmIdentities() {
  const workspaceSlug = useLoginStore((s) => s.workspaceSlug)

  const { data } = useQuery({
    queryKey: ['scm-identities', workspaceSlug],
    queryFn: () => listScmIdentities(workspaceSlug as string),
    enabled: !!workspaceSlug,
    staleTime: 5 * 60 * 1000,
  })

  return useMemo(() => {
    const map = new Map<string, ScmIdentity>()
    for (const id of data ?? []) map.set(id.login.toLowerCase(), id)
    return map
  }, [data])
}
